<template>
  <div
    class="msg-image"
    :class="{ 'fake-image': !isRealImage }"
    :style="styleWH"
  >
    <img
      ref="imgEle"
      :src="formatPath"
      @load="onLoad"
      @click="viewImage"
      crossorigin="anonymous"
      class="pic"
    />
  </div>
</template>

<script>
import globalWin from '@/utils/globalWin';
import { getScrollBottom, scrollLimit } from '@/utils/scroll.ts';
import axios from 'axios';
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';

export default {
  inject: ['messageList', 'IMSDKType'],
  props: {
    data: Object,
  },
  data() {
    return {
      formatPath: '',
      // 查看大图的地址。本地会先使用blob地址，但部分用户有保存图片的需求，因此需要上传完成之后替换一下。
      viewPath: '',
      isRealImage: false,
      copyBlob: null,
      imageExt: '.png', // 图片后缀
    };
  },
  computed: {
    formatTime() {
      const date = new Date(this.data.time);
      return date.toLocaleDateString() + date.toLocaleTimeString();
    },

    // 计算图片的宽高
    styleWH() {
      const MAX_PX = 200;

      const { imageWidth: width, imageHeight: height } = this.data;

      if (!width || !height) {
        return '';
      }

      if (width < MAX_PX && height < MAX_PX) {
        return `width:${width}px; height:${height}px`;
      }

      const ratio = width / height;
      let w = '';
      let h = '';
      if (width > height) {
        w = MAX_PX;
        h = MAX_PX / ratio;
      } else {
        h = MAX_PX;
        w = MAX_PX * ratio;
      }

      return `width:${w}px; height:${h}px`;
    },
  },
  watch: {
    'data.tempPath': {
      async handler(val) {
        if (!val) {
          return;
        }
        this.viewPath = await this.getNetworkImg(val);
      },
      deep: true,
      immediate: true,
    },

    viewPath(val) {
      if (val) {
        this.$set(this.data, 'viewPath', val);
      }
    },
  },
  async mounted() {
    // 如果是本地blob图片，或者是外链其他图片，则直接展示
    if (this.data.uuid === 'blob' || this.data.path.indexOf('http') === 0) {
      this.formatPath = this.data.path;
      // 如果是网络图片，则可以预览
      if (this.formatPath.indexOf('http') === 0) {
        this.viewPath = this.formatPath;
      }
      return;
    }

    // 获得存储的文件路径
    this.formatPath = await this.getNetworkImg(this.data.path);

    if (this.formatPath) {
      this.viewPath = this.formatPath;
      axios
        .get(`${this.formatPath}&imageInfo`)
        .then((res) => {
          const imageInfo = res.data;
          this.imageExt = `.${imageInfo.format}`;
        })
        .catch((error) => {
          console.log('axios', error);
        });
    }
  },
  methods: {
    // 根据path获得网络图片地址
    async getNetworkImg(path) {
      return await SDKUtils.getDownloadUrl({
        path,
        size: this.data.imageSize,
        name: this.data.imageName,
      }, IMSDK.OBJTYPES.OBJ_IMAGE);
    },

    viewImage() {
      // 上传成功后才可查看大图。
      if (!this.viewPath) {
        return;
      }
      // TODO
      const imageArray = [];
      this.messageList.forEach((msg) => {
        if (msg.type === this.IMSDKType.MSG_IMAGE) {
          msg.viewPath && imageArray.push(msg.viewPath);
        }
      });
      const conf = {
        current: this.viewPath,
        array: imageArray,
      };
      console.log(conf);
      const index = conf.array.indexOf(conf.current);
      this.$PictureViewer.show({
        showPhotoPreView: true,
        photoPreviewIndex: index,
        photoUrls: conf.array,
        closeOnClickMask: false,
      });
    },
    onLoad() {
      this.isRealImage = true;

      // 图片尺寸消失了，只能自行判断是否滚动到底部
      // 如果极短时间内有多张图片出现，就不判断位置了，直接滚动到底部
      if ((globalWin.LAST_SHOW_IMG_TIME && (Date.now() - globalWin.LAST_SHOW_IMG_TIME < 300))
        || getScrollBottom() < scrollLimit) {
        globalWin.scrollToBottom(true, 500);
        globalWin.LAST_SHOW_IMG_TIME = Date.now();
      }
    },
  },
  beforeDestroy() {
    if (this.copyBlob) {
      this.copyBlob = null;
    }
  },
};
</script>

<style lang="less" scoped>
.msg-image {
  padding: 0;
  position: relative;
  border-radius: inherit;

  &.fake-image{
    background: #eeeeee;
    min-width: 50px;
    min-height: 60px;
    display: flex;
    align-items:center;
    justify-content: center;
    &:before{
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      background: #eeeeee url('./assets/loading.svg') no-repeat center;
      background-size: contain;
      animation: anim-rotate 1s linear infinite;
      position: absolute;
    }
  }

  .pic {
    position: relative;
    z-index: 1;
    display: block;
    max-width: 200px;
    max-height: 200px;
    border-radius: inherit;
  }

  @keyframes anim-rotate {
    0%{
      transform: rotate(0);
    }
    100%{
      transform: rotate(360deg);
    }
  }
}
</style>
